import React from 'react';
import styled from 'styled-components';

import pxToViewport from '../../../utils/px-to-viewport-units';
import { IRouteList } from './PortraitRouteList';

const Bullet = styled.div`
  margin: ${pxToViewport(25)}rem;
  padding: ${pxToViewport(25)}rem ${pxToViewport(25)}rem;
  border-radius: ${pxToViewport(10)}rem;
  font-size: ${pxToViewport(60)}rem;
  font-weight: bold;
  letter-spacing: -${pxToViewport(1.11)}rem;
`;

const LandscapeRouteList: React.FC<IRouteList> = ({
  affectedRoutes,
  allRoutesAffected,
}) => {
  if (!affectedRoutes) {
    return null;
  }

  if (allRoutesAffected) {
    return (
      <Bullet style={{ backgroundColor: '#fff', color: '#000' }}>
        All Branches
      </Bullet>
    );
  }

  const bulletEls = affectedRoutes
    .map(route => {
      const { gtfsId, color, textColor, shortName, longName } = route;
      const name = shortName || longName;

      if (!name) {
        return null;
      }

      return (
        <Bullet
          key={gtfsId}
          style={{
            backgroundColor: color ? `#${color}` : '',
            color: textColor ? `#${textColor}` : '',
          }}
        >
          {name}
        </Bullet>
      );
    })
    .filter(Boolean)
    .slice(0, 4);

  return <>{bulletEls}</>;
};

export default LandscapeRouteList;
